import React from 'react'
import { Box, Table, TableContainer } from '@mui/material'
import { Head } from './Head'
import { Pagination } from './Pagination'
import { Body } from './Body'
import { Actions, Field, Pager, Search, Sort } from './types'
import { Searcher } from './Searcher'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { ListTable } from './ListTable'
import { useIsOpenMenuLeftContext } from '../../common/utils/isOpenMenuLeftContext'
import styles from './AppTable.module.css'

const DEFAULT_ROW_KEY = 'id'

export type TableProps<T, Q> = {
  readonly fields: Field<T>[]
  readonly items: T[]
  readonly rowKeyField: keyof T
  readonly actions?: Actions<T>
  readonly search?: Search<Q>
  readonly sort?: Sort<T>
  readonly pager?: Pager
  readonly isLoading?: boolean
}

export function AppTable<T extends { [key: string]: any }, Q extends { [key: string]: any }>(
  props: TableProps<T, Q>
) {
  const { openMenuLeft } = useIsOpenMenuLeftContext()
  const innerWidth = window.innerWidth

  return (
    <>
      <TableContainer
        className={`${styles.tableContainer} ${
          openMenuLeft ? styles.tableContainerOpen : styles.tableContainerClosed
        }`}
      >
        <Table className={styles.table}>
          <div
            className={`${styles.tableInner} ${
              openMenuLeft ? styles.tableInnerOpen : styles.tableInnerClosed
            }`}
          >
            <Head fields={props.fields} sort={props.sort} actions={props.actions} />
            <Body
              actions={props.actions}
              fields={props.fields}
              items={props.items}
              rowKeyField={props.rowKeyField || DEFAULT_ROW_KEY}
              isLoading={props.isLoading}
            />
          </div>
        </Table>
      </TableContainer>
    </>
  )
}
